import ModalNuevoUsuario from './ModalUsuario';

export default ModalNuevoUsuario;
